import { replacePathParams } from '@/api/utils';

export const missionPlannerPaths = {
  createBenchmark: '/mission-planner/api/plans/benchmark',
  getBenchmarkById: '/mission-planner/api/plans/benchmark/:planId',
  getRefuelAirports: '/mission-planner/api/airportsMiddles/readByMaoIds',
  generateFullPlans: '/mission-planner/api/plans-multi-or/full',
  getFullPlans: '/mission-planner/api/plans-multi-or/:taskId',
  getSurgeonTripPlans: '/mission-planner/api/plans-multi-or/:taskId/surgeonTrips',
  getCommercialFlightsPlans: '/mission-planner/api/plans-multi-or/:taskId/planCommercialFlights',
  generatePartialPlan: '/mission-planner/api/plans/partial',
  getPartialPlan: '/mission-planner/api/plans/partial/:taskId',
  getPartialCommercialFlightsPlan: '/mission-planner/api/plans/partial/:taskId/planCommercialFlights',
} as const;

export const getMissionPlannerApiUrl = {
  createBenchmark: () => missionPlannerPaths.createBenchmark,
  getBenchmarkById: (planId: string) => replacePathParams(missionPlannerPaths.getBenchmarkById, { planId }),
  getRefuelAirports: () => missionPlannerPaths.getRefuelAirports,
  generateFullPlans: () => missionPlannerPaths.generateFullPlans,
  getFullPlans: (taskId: string) => replacePathParams(missionPlannerPaths.getFullPlans, { taskId }),
  getSurgeonTripPlans: (taskId: string) => replacePathParams(missionPlannerPaths.getSurgeonTripPlans, { taskId }),
  getCommercialFlightsPlans: (taskId: string) =>
    replacePathParams(missionPlannerPaths.getCommercialFlightsPlans, { taskId }),
  generatePartialPlan: () => missionPlannerPaths.generatePartialPlan,
  getPartialPlan: (taskId: string) => replacePathParams(missionPlannerPaths.getPartialPlan, { taskId }),
  getPartialCommercialFlightsPlan: (taskId: string) =>
    replacePathParams(missionPlannerPaths.getPartialCommercialFlightsPlan, { taskId }),
};
